import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const CircleArrowRight = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_4539_71255)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24 12C24 18.6278 18.6278 24 12 24C5.37223 24 4.69655e-07 18.6278 1.04907e-06 12C1.22723e-06 9.96215 0.509463 7.99515 1.46688 6.24592C2.20268 4.90263 3.19065 3.7104 4.37369 2.73404C6.5074 0.977406 9.17992 8.02534e-07 12 1.04907e-06C18.6278 1.62849e-06 24 5.37223 24 12ZM1.1999 12C1.1999 17.965 6.03487 22.8 11.9999 22.8C17.9649 22.8 22.7999 17.965 22.7999 12C22.7999 6.03497 17.9649 1.2 11.9999 1.2C9.46077 1.2 7.05719 2.07905 5.13686 3.66002C4.07155 4.53921 3.18165 5.61309 2.51933 6.82224C1.65809 8.39575 1.1999 10.1648 1.1999 12Z'
          fill='currentColor'
        />
        <path
          d='M14.9102 12L9.68331 6.51222C9.57177 6.39511 9.5717 6.20516 9.68314 6.08796C9.79459 5.97075 9.97536 5.97067 10.0869 6.08778L15.5159 11.7878C15.6275 11.905 15.6275 12.095 15.5159 12.2122L10.0869 17.9122C9.97536 18.0293 9.79459 18.0293 9.68314 17.912C9.5717 17.7948 9.57177 17.6049 9.68331 17.4878L14.9102 12Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='0.5'
        />
      </g>
      <defs>
        <clipPath id='clip0_4539_71255'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='matrix(1 8.74228e-08 8.74228e-08 -1 0 24)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
